import * as Yup from 'yup';

export const passportValidation = Yup.object().shape({
  title: Yup.string(),
  description: Yup.string().required('Please enter a description is required'),
  firstname: Yup.string().required('First name is required'),
  lastname: Yup.string().required('Last name is required'),
  passportNo: Yup.string().required('Passport number is required'),
});
